<style scoped>
.next-button {
  align-self: center;
  background-color: #6bb53b;
}
input {
  width: 20px;
  height: 20px;

  border: 1px solid black;

  margin-right: 4px;
}

.checkbox-wrapper {
  display: flex;
  justify-content: center;
}
</style>

<template>
  <div class="card">
    <div class="card-body">
      <div class="d-flex flex-column">
        <div class="checkbox-wrapper">
          <input
            type="checkbox"
            id="tos_privacy"
            v-model="tos_privacy"
            label
          /><label for="tos_privacy">
            Ich akzeptiere die <a target="_blank" href="/agb">AGB</a> und
            willige der
            <a target="_blank" href="/datenschutz">Datenschutzerklärung</a> ein.
          </label>
          <br />
        </div>
        <div class="checkbox-wrapper">
          <input type="checkbox" id="privacy" v-model="age" /><label
            for="privacy"
            >Hiermit bestätige ich, dass ich mindestens 18 Jahre alt bin.</label
          >
          <br />
        </div>
        <button
          :disabled="working"
          class="btn btn-primary w-100 next-button"
          @click="select"
        >
          <span v-if="working"
            ><i class="fa fa-spinner fa-spin" aria-hidden="true"></i> einen
            Augenblick noch...</span
          >
          <span v-else>
            Weiter
          </span>
        </button>
        <div v-if="hasErrors" class="row">
          <div class="col-12 pt-3">
            <div class="alert alert-danger" role="alert">
              <div v-for="(error, name) in errors.errors" :key="name">
                {{ error[0] }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["errors", "working"],
  data() {
    return {
      tos_privacy: false,
      age: false
    };
  },
  computed: {
    hasErrors() {
      return this.errors !== null;
    }
  },
  methods: {
    select() {
      this.$emit("input", {
        tos_privacy: this.tos_privacy,
        age: this.age
      });
    }
  }
};
</script>
